function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  rx: 2,
  fill: "white",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.47 22.2926C10.47 19.8617 12.277 17.8857 14.5 17.8857H19.7V15.1847H14.5C10.912 15.1847 8 18.369 8 22.2926C8 26.2161 10.912 29.4004 14.5 29.4004H19.7V26.6995H14.5C12.277 26.6995 10.47 24.7235 10.47 22.2926ZM15.8 23.7142H26.2V20.871H15.8V23.7142ZM27.5 15.1847H22.3V17.8857H27.5C29.723 17.8857 31.53 19.8617 31.53 22.2926C31.53 24.7235 29.723 26.6995 27.5 26.6995H22.3V29.4004H27.5C31.088 29.4004 34 26.2161 34 22.2926C34 18.369 31.088 15.1847 27.5 15.1847Z",
  fill: "white"
});

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.8196e34b89767fe1e755dc858823477e646bd945c3b29c2e4bc0fd109c775811.svg";
export { ForwardRef as ReactComponent };